<template>
    <div class="na-form">
        <div v-if="modulTypeDetail" class="left">
            <DxTabPanel>
                <DxItem :title="tx.TabBaseData">
                    <div class="dx-fieldset">
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.MtyId }}:</div>
                            <div class="dx-field-value">
                                <DxTextBox :value='modulTypeDetail.MtyId' :readOnly="true" />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.MtyName }}:</div>
                            <div class="dx-field-value">
                                <DxTextBox v-model:value='modulTypeDetail.MtyName' />
                            </div>
                            <!--<div class="udc-description">
                                <div class="udc-field-required">*</div>
                                <div class="udc-field-description"></div>
                            </div>-->
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.MtyDescription }}:</div>
                            <div class="dx-field-value">
                                <DxTextArea v-model:value='modulTypeDetail.MtyDescription' :autoResizeEnabled="true" />
                            </div>
                            <!--<div class="udc-description">
                                <div class="udc-field-required">*</div>
                                <div class="udc-field-description"></div>
                            </div>-->
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.MtyAccessRightManagementVersion }}:</div>
                            <div class="dx-field-value">
                                <DxSelectBox :dataSource="accessRightManagementVersionList" valueExpr="Id" displayExpr="Name" v-model:value="modulTypeDetail.MtyAccessRightManagementVersion">
                                </DxSelectBox>
                            </div>
                            <!--<div class="udc-description">
                                <div class="udc-field-required">*</div>
                                <div class="udc-field-description"></div>
                            </div>-->
                        </div>





                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.MtyChangedOn }}:</div>
                            <div class="dx-field-value">
                                <DxDateBox :value='modulTypeDetail.MtyChangedOn' :readOnly="true" />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.MtyChangedBy }}:</div>
                            <div class="dx-field-value">
                                <DxTextBox :value='modulTypeDetail.MtyChangedBy' :readOnly="true" />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.MtyCreatedOn }}:</div>
                            <div class="dx-field-value">
                                <DxDateBox :value='modulTypeDetail.MtyCreatedOn' :readOnly="true" />
                            </div>

                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.MtyCreatedBy }}:</div>
                            <div class="dx-field-value">
                                <DxTextBox :value='modulTypeDetail.MtyCreatedBy' :readOnly="true" />
                            </div>
                        </div>
                    </div>
                </DxItem>
                <DxItem :title="tx.TabFields">
                    <DxDataGrid id="tsGridFields"
                                :data-source="masPivot"
                                key-expr="MatId"
                                :remote-operations="false"
                                :allow-column-reordering="true"
                                :row-alternation-enabled="true"
                                :show-borders="true"
                                @exporting="onExporting"
                                :columns="masColumns">
                        <DxLoadPanel :enabled="true" />
                        <DxScrolling mode="virtual" />
                        <DxColumnChooser :enabled="true" />
                        <DxColumnFixing :enabled="true" />
                        <DxFilterRow :visible="true" />
                        <DxEditing :allow-updating="true"
                                   :allow-adding="false"
                                   :allow-deleting="false"
                                   select-text-on-edit-start="true"
                                   start-edit-action="click"
                                   mode="cell" />
                        <DxHeaderFilter :visible="true" />
                        <DxSearchPanel :visible="true"
                                       :width="240"
                                       :placeholder="tx.TabSearchPlaceholder" />
                        <DxExport :enabled="true"
                                  :allow-export-selected-data="true" />
                        <template #headerTemplate="{ data }">
                            <div class="tsHeaderCell">{{data.column.caption}}</div>
                        </template>
                        <template #cellTemplate="{ data }">
                            <div class="tsCell">{{data.value}}</div>
                        </template>
                    </DxDataGrid>
                    <div class="na-description">
                        R: readonly, U: Update (writable), M: Mandatory (writable)
                    </div>

                </DxItem>
            </DxTabPanel>
            <div class="na-buttons-row">
                <div>
                    <DxButton :width="120"
                              :text="btn.Save"
                              :type="saveButtonType"
                              :disabled="saveButtonDisabled"
                              styling-mode="contained"
                              @click="onSaveClick($event)" />
                </div>
                <div>
                    <DxButton :width="120"
                              :text="btn.Delete"
                              type="danger"
                              styling-mode="contained"
                              @click="onDeleteClick($event)" />
                </div>

                <div>
                    <DxButton :width="120"
                              :text="btn.Back"
                              type="default"
                              @click="onCancelClick($event)" />
                </div>


            </div>


        </div>
    </div>

    <!--{{ masPivot  }}-->
</template>

<script>
    import { DxTextBox, DxTextArea } from 'devextreme-vue'
    import { DxButton } from 'devextreme-vue/button'
    import { DxSelectBox } from 'devextreme-vue/select-box'
    import { DxTabPanel } from 'devextreme-vue/tab-panel'
    import {
        DxDataGrid, DxEditing, DxLoadPanel, DxScrolling, DxColumnChooser, DxColumnFixing,
        DxHeaderFilter, DxSearchPanel, DxExport
    } from 'devextreme-vue/data-grid'
    import { DxItem } from 'devextreme-vue/html-editor'
    import { DxDateBox } from 'devextreme-vue/date-box'
    import { confirm } from "devextreme/ui/dialog"
    import $ from 'jquery';
    import { nextTick } from 'vue';

    import { exportDataGrid } from 'devextreme/excel_exporter';
    import { Workbook } from 'exceljs';
    import saveAs from 'file-saver';

    export default {
        name: 'ModulTypeDetail',
        components: {

            DxButton, DxTabPanel, DxItem, DxTextArea,
            DxTextBox, DxDataGrid, DxEditing, DxLoadPanel, DxScrolling,
            DxDateBox, DxColumnChooser, DxColumnFixing,
            DxHeaderFilter, DxSearchPanel, DxExport, DxSelectBox

        },
        data() {
            return {
                tx: {
                    TabBaseData: this.$LanguageProvider.GetResource("TabBaseData", "Caption", "Basisdaten"),
                    TabFields: this.$LanguageProvider.GetResource("TabFields", "Caption", "Felder"),
                    TabSearchPlaceholder: this.$LanguageProvider.GetResource("TabSearchPlaceholder", "Caption", "Suchen..."),
                    MtyId: this.$LanguageProvider.GetResource("MtyId", "Caption", "ID"),
                    MtyName: this.$LanguageProvider.GetResource("MtyName", "Caption", "Name"),
                    MtyDescription: this.$LanguageProvider.GetResource("MtyDescription", "Caption", "Beschreibung"),
                    MtyAccessRightManagementVersion: this.$LanguageProvider.GetResource("MtyAccessRightManagementVersion", "Caption", "Zugriffskontrolle Version"),
                    MtyChangedOn: this.$LanguageProvider.GetResource("MtyChangedOn", "Caption", "Geändert am"),
                    MtyChangedBy: this.$LanguageProvider.GetResource("MtyChangedBy", "Caption", "Geändert von"),
                    MtyCreatedOn: this.$LanguageProvider.GetResource("MtyCreatedOn", "Caption", "Erstellt am"),
                    MtyCreatedBy: this.$LanguageProvider.GetResource("MtyCreatedBy", "Caption", "Erstellt von")
                },
                col: {
                    Selected: this.$LanguageProvider.GetResource("Selected", "Column", "Ausgewählt"),
                    Attribute: this.$LanguageProvider.GetResource("Attribute", "Caption", "Attribute"),
                    RgrAllowed: this.$LanguageProvider.GetResource("RgrAllowed", "Column", "Sichtbar"),
                    TtrAllowed: this.$LanguageProvider.GetResource("TtrAllowed", "Column", "Sichtbar"),
                    TtrName: this.$LanguageProvider.GetResource("TtrName", "Caption", "Thementyp"),
                    TtyName: this.$LanguageProvider.GetResource("TtyName", "Caption", "Alias"),
                    GrpName: this.$LanguageProvider.GetResource("GrpName", "Caption", "Rolle"),
                },
                btn: {
                    Save: this.$LanguageProvider.GetResource("Save", "Button", "Speichern"),
                    Delete: this.$LanguageProvider.GetResource("Delete", "Button", "Löschen"),
                    Back: this.$LanguageProvider.GetResource("Back", "Button", "Zurück"),
                }
            };
        },
        computed: {
            lang() {
                return this.$LanguageProvider
            },
            modulTypeDetail() {
                return this.$store.state.modulTypeStore.modulTypeDetail
            },
            modulTypeDetailText() {
                return JSON.stringify(this.$store.state.modulTypeStore.modulTypeDetail)
            },
            pivotDataText() {
                return JSON.stringify(this.$store.state.modulTypeStore.masPivot)
            },
            modulTypeStatusAttributeList() {
                return this.$store.state.modulTypeStore.modulTypeStatusAttributeList
            },
            modulTypeStatusAttributeListText() {
                return JSON.stringify(this.$store.state.modulTypeStore.modulTypeStatusAttributeList)
            },
            modulTypeStatusList() {
                return this.$store.state.modulTypeStore.modulTypeStatusList
            },
            modulTypeStatusListText() {
                return JSON.stringify(this.$store.state.modulTypeStore.modulTypeStatusList)
            },
            saveButtonType() {
                return this.$store.state.modulTypeStore.modulTypeDetailChanged || this.$store.state.modulTypeStore.masPivotChanged
                    ? "success" : "normal"
            },
            saveButtonDisabled() {
                return this.$store.state.modulTypeStore.modulTypeDetailChanged || this.$store.state.modulTypeStore.masPivotChanged
                    ? false : true
            },
            modulTypeStatusAttributePivotList() {
                return this.$store.state.modulTypeStore.modulTypeStatusAttributePivotList
            },
            masPivot() {
                return this.$store.state.modulTypeStore.masPivot
            },
            masColumns() {
                return this.$store.state.modulTypeStore.masColumns
            },
            accessRightManagementVersionList() {
                return this.$store.state.modulTypeStore.accessRightManagementVersionList
            },

        },
        props: {
            mtyId: {
                type: [Number],
                required: true,
                default: 0
            },
        },
        watch: {
            modulTypeDetailText: function (newVal, oldVal) {
                if (oldVal != "{}") {
                    this.$store.state.modulTypeStore.modulTypeDetailChanged = true
                }
            },
            pivotDataText: function (newVal, oldVal) {
                if (oldVal != "{}") {
                    this.$store.state.modulTypeStore.masPivotChanged = true
                }
            },
        },
        mounted: function () {
            let vm = this
            this.$store.dispatch("getModulTypeDetail", { mtyId: vm.mtyId })
            this.$store.dispatch("getModulTypeAttributeStatusData", { mtyId: vm.mtyId })
        },
        methods: {
            onExporting(e) {
                e.component.beginUpdate();
                const workbook = new Workbook();
                const worksheet = workbook.addWorksheet('Data');
                exportDataGrid({
                    component: e.component,
                    worksheet: worksheet
                }).then(function () {
                    workbook.xlsx.writeBuffer().then(function (buffer) {
                        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Data.xlsx');
                    });
                }).then(function () {
                    e.component.endUpdate();
                });
            },
            onCancelClick() {
                $("form").attr("action", window.location.pathname + "?action=cancel").submit();
            },
            async onSaveClick() {
                await nextTick()
                this.$store.dispatch("saveModulTypeDetail")
                //setTimeout(() => this.$store.dispatch("saveModulTypeDetail"), 100);
            },
            onDeleteClick() {
                let result = confirm("Sind Sie sicher, dass Sie den Modul-Typ löschen möchten? Ein Löschen ist nicht möglich, wenn verknüpfte Datensätze bestehen", "Löschen bestätigen");
                result.then((dialogResult) => {
                    if (dialogResult) {
                        this.$store.dispatch("deleteModulTypeDetail")
                    }
                });
            },
        }
    }


</script>
<style>
    div#tsGridFields {
        max-height: 620px;
    }


    .tsHeaderCell.dx-template-wrapper {
        writing-mode: vertical-rl;
    }

    .dx-datagrid-nowrap .dx-header-row > td.tsDynHeader > .dx-datagrid-text-content {
        display: inline;
    }
</style>
<style scoped>
    .na-description {
        padding: 10px;
    }
</style>
